export default __webpack_public_path__ + "static/media/6.d7ec8dd0.jpg";